import isNil from "lodash/isNil";
import { useQuery } from "urql";

import { GetClikNegativeEventsDocument } from "../../../graphql/generated.ts";

interface Props {
  clikResultId: number;
}

export function useClikNegativeEvents({ clikResultId }: Props) {
  return useQuery({
    query: GetClikNegativeEventsDocument,
    variables: { clikResultId: Number(clikResultId) },
    pause: isNil(clikResultId),
  });
}
